export enum OperationTypeMapEnum {
  Sale = 'Sale',
  VerifyOnly = 'VerifyOnly',
  ForceSale = 'ForceSale',
  Adjust = 'Adjust',
  Activate = 'Activate',
  Deactivate = 'Deactivate',
  Reload = 'Reload',
  Refund = 'Refund',
  Inquire = 'Inquire',
  ReverseAuth = 'ReverseAuth',
}
